import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAccountingPeriodConfiguration } from './accountingPeriod';
import type { AccountingPeriodConfiguration } from './accountingPeriod.types';
import { ACCOUNTING_PERIOD_CONFIG_KEY } from './constants';

export const useUpdateAccountingPeriodConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAccountingPeriodConfiguration,
    onSuccess: (updatedConfiguration: AccountingPeriodConfiguration) => {
      // Update the configuration cache
      queryClient.setQueryData(
        [ACCOUNTING_PERIOD_CONFIG_KEY],
        updatedConfiguration,
      );

      // Return the updated configuration
      return updatedConfiguration;
    },
  });
};
